import { Component } from '@angular/core';

@Component({
    selector: 'app-chat-message-loading',
    templateUrl: './chat-message-loading.html',
    styleUrls: ['./chat-message-loading.scss'],
    standalone: false
})
export class ChatMessageLoading {

}
